"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Chip = _interopRequireDefault(require("@material-ui/core/Chip"));
var _colors = require("@material-ui/core/colors");
var _unsupportedProp = _interopRequireDefault(require("@material-ui/core/utils/unsupportedProp"));
var _ArrowDropDown = _interopRequireDefault(require("@material-ui/icons/ArrowDropDown"));
var _styles = require("@material-ui/core/styles");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _excluded = ["alternativeSelectedStyle", "classes", "clickable", "color", "dataMetrics", "disabled", "deleteIcon", "icon", "label", "onDelete", "onDropDown", "selected", "size", "variant"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var baseFocusVisibleClasses = {
  content: "''",
  height: 'calc(100% + 4px)',
  left: -2,
  position: 'absolute',
  top: -2,
  width: 'calc(100% + 4px)'
};
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var focusVisibleClasses = {
    "default": {
      "default": {
        '&:before': _objectSpread({}, baseFocusVisibleClasses, {
          border: "2px solid ".concat(theme.palette.opacity.black[87])
        })
      },
      primary: {
        '&:before': _objectSpread({}, baseFocusVisibleClasses, {
          border: "2px solid ".concat(theme.palette.primary.main)
        })
      }
    },
    outlined: {
      "default": {
        '&:before': _objectSpread({}, baseFocusVisibleClasses, {
          border: "2px solid ".concat(theme.palette.opacity.black[87])
        })
      },
      primary: {
        '&:before': _objectSpread({}, baseFocusVisibleClasses, {
          border: "2px solid ".concat(theme.palette.primary.main)
        })
      }
    }
  };
  var rootPaddingConfig = function rootPaddingConfig(_ref) {
    var deleteIcon = _ref.deleteIcon,
      icon = _ref.icon,
      onDelete = _ref.onDelete,
      onDropDown = _ref.onDropDown;
    var isDeleteIcon = onDropDown || deleteIcon || onDelete;
    if (icon && !isDeleteIcon) {
      return theme.spacing(0, 1.5, 0, 0);
    }
    if (!icon && isDeleteIcon) {
      return theme.spacing(0, 0, 0, 1.5);
    }
    if (icon && isDeleteIcon) {
      return theme.spacing(0, 0, 0, 0);
    }
    return theme.spacing(0, 1.5);
  };
  return {
    chipActive: {},
    clickable: {},
    clickableColorPrimary: {
      '&$outlinedPrimary$clickable:hover': {
        backgroundColor: theme.palette.opacity.primary[800][8]
      },
      /**
       * "To style links appropriately, put the :active
       * rule after all other link-related rules,
       * as defined by the LVHA-order: :link — :visited — :hover — :active."
       * https://developer.mozilla.org/en-US/docs/Web/CSS/:active
       */
      // eslint-disable-next-line sort-keys
      '&$outlinedPrimary$clickable:active': {
        backgroundColor: theme.palette.opacity.primary[800][14]
      },
      '&$outlinedPrimary$clickable:focus': {
        backgroundColor: 'transparent'
      }
    },
    colorPrimary: {},
    deleteIcon: {
      '$colorPrimary &, $colorPrimary &:hover': {
        color: theme.palette.opacity.white[70]
      },
      '$colorPrimary$outlinedPrimary &, $colorPrimary$outlinedPrimary &:hover': {
        color: theme.palette.opacity.primary[800][60]
      },
      '$outlinedPrimary &, $outlinedPrimary &:hover': {
        color: theme.palette.opacity.primary[800][60]
      },
      '&:hover': {
        color: theme.palette.opacity.black[60]
      },
      color: theme.palette.opacity.black[60],
      height: function height(_ref2) {
        var size = _ref2.size;
        return size === 'small' ? theme.spacing(2) : theme.spacing(3);
      },
      width: function width(_ref3) {
        var size = _ref3.size;
        return size === 'small' ? theme.spacing(2) : theme.spacing(3);
      }
    },
    disabled: {
      '&$outlined, &$outlined:active, &$outlined:focus, &$outlined:hover, &$outlined$outlinedPrimary, &$outlined$outlinedPrimary:hover': {
        '& > $iconDisabled': {
          color: theme.palette.opacity.black[38],
          cursor: 'default'
        },
        backgroundColor: _colors.common.white,
        border: "1px solid ".concat(theme.palette.opacity.black[38]),
        boxShadow: 'none',
        color: theme.palette.opacity.black[38],
        cursor: 'default'
      },
      '&:not($outlined)': {
        '& > $iconDisabled': {
          color: theme.palette.opacity.black[38],
          cursor: 'default'
        },
        backgroundColor: theme.palette.opacity.black[8],
        boxShadow: 'none',
        color: theme.palette.opacity.black[38],
        cursor: 'default'
      }
    },
    focusVisible: function focusVisible(_ref4) {
      var color = _ref4.color,
        variant = _ref4.variant;
      return _objectSpread({}, focusVisibleClasses[variant][color]);
    },
    icon: {
      '$colorPrimary &$iconColorPrimary': {
        color: theme.palette.white
      },
      '$outlined$outlinedPrimary &, $outlined$outlinedPrimary &:hover': {
        color: theme.palette.primary.main
      },
      color: theme.palette.opacity.black[60]
    },
    iconColorPrimary: {},
    iconDisabled: {},
    iconSmall: {
      fontSize: '16px',
      margin: '0 4px'
    },
    label: {
      '$colorPrimary &:not($labelDisabled)': {
        color: theme.palette.common.white
      },
      '$outlinedPrimary &:not($labelDisabled)': {
        color: theme.palette.opacity.black[87]
      },
      color: theme.palette.opacity.black[87]
    },
    labelDisabled: {
      color: theme.palette.opacity.black[38]
    },
    labelOutlined: {},
    labelSelected: {
      '&$labelOutlined': {
        color: theme.palette.opacity.black[87]
      },
      color: _colors.common.white
    },
    labelSmall: {
      fontWeight: 500,
      padding: 0
    },
    outlined: {
      '&:active, &:focus, &$clickable:focus': {
        backgroundColor: theme.palette.opacity.black[14]
      }
    },
    outlinedPrimary: {},
    root: {
      '&$clickable$chipActive': {
        backgroundColor: theme.palette.opacity.black[24]
      },
      '&$colorPrimary$clickableColorPrimary$clickable:focus': {
        backgroundColor: theme.palette.primary.main
      },
      '&$colorPrimary$clickableColorPrimary$clickable:hover': {
        backgroundColor: theme.palette.opacity.primary[800][86]
      },
      '&$colorPrimary$clickableColorPrimary$outlinedPrimary$clickable:focus': {
        backgroundColor: 'transparent'
      },
      '&$colorPrimary$clickableColorPrimary$outlinedPrimary$clickable:hover': {
        backgroundColor: theme.palette.opacity.primary[800][8]
      },
      '&$colorPrimary$focusVisible': {
        backgroundColor: theme.palette.primary.main
      },
      '&$focusVisible': {
        backgroundColor: theme.palette.opacity.black[8]
      },
      '&$outlined': {
        '&$focusVisible': {
          backgroundColor: 'transparent'
        },
        backgroundColor: 'transparent'
      },
      '&&$colorPrimary$clickableColorPrimary$clickable$chipActive': {
        backgroundColor: theme.palette.opacity.primary[800][62]
      },
      '&&$colorPrimary$clickableColorPrimary$outlinedPrimary$clickable$chipActive': {
        backgroundColor: theme.palette.opacity.primary[800][14]
      },
      borderRadius: function borderRadius(_ref5) {
        var size = _ref5.size;
        return size === 'small' ? theme.spacing(1.5) : theme.spacing(2);
      },
      height: function height(_ref6) {
        var size = _ref6.size;
        return size === 'small' ? theme.spacing(3) : theme.spacing(4);
      },
      padding: function padding(_ref7) {
        var icon = _ref7.icon,
          deleteIcon = _ref7.deleteIcon,
          onDelete = _ref7.onDelete,
          onDropDown = _ref7.onDropDown;
        return rootPaddingConfig({
          deleteIcon: deleteIcon,
          icon: icon,
          onDelete: onDelete,
          onDropDown: onDropDown
        });
      }
    },
    selected: {
      '&:not($disabled)': {
        '& $deleteIcon, &$clickable > $icon, &$clickable > $label': {
          color: theme.palette.opacity.white[60]
        },
        '&$clickable$focusVisible:before': {
          border: "2px solid ".concat(theme.palette.primary.main)
        },
        '&$outlined': {
          '& > $icon, & > $deleteIcon': {
            color: theme.palette.opacity.primary[800][60]
          },
          '& > $label': {
            color: theme.palette.opacity.black[87]
          },
          backgroundColor: theme.palette.opacity.primary[800][14],
          borderColor: theme.palette.primary.main
        },
        '&:active': {
          boxShadow: 'none'
        },
        backgroundColor: theme.palette.opacity.primary[800][62],
        cursor: 'default'
      }
    }
  };
});
var defaultProps = {
  color: 'default',
  dataMetrics: {
    root: 'fuse_chip'
  },
  size: 'medium',
  variant: 'default'
};

/**
 * Chips are used for filtering, as tags and labels, or as action items.
 * Chip are usually interactive.
 */
var Chip = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _cx2, _cx4, _cx5, _cx6;
  var alternativeSelectedStyle = props.alternativeSelectedStyle,
    _props$classes = props.classes,
    classes = _props$classes === void 0 ? {} : _props$classes,
    clickable = props.clickable,
    color = props.color,
    dataMetrics = props.dataMetrics,
    disabled = props.disabled,
    deleteIcon = props.deleteIcon,
    icon = props.icon,
    label = props.label,
    onDelete = props.onDelete,
    onDropDown = props.onDropDown,
    selected = props.selected,
    size = props.size,
    variant = props.variant,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var localClasses = useStyles({
    color: color,
    deleteIcon: deleteIcon,
    icon: icon,
    onDelete: onDelete,
    onDropDown: onDropDown,
    size: size,
    variant: variant
  });
  var mergedClasses = Object.entries(classes).reduce(function (acc, _ref8) {
    var _ref9 = (0, _slicedToArray2["default"])(_ref8, 2),
      key = _ref9[0],
      value = _ref9[1];
    if (key in localClasses) {
      acc[key] = (0, _classnames["default"])(value, localClasses[key]);
    }
    return acc;
  }, _objectSpread({}, localClasses));
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isChipActive = _useState2[0],
    setIsChipActive = _useState2[1];
  var isSmall = size === 'small';

  // react complains about focusVisibleClassName not being lowercase
  // when a chip is NOT clickable, so this code handles that sadly...
  var focusVisibleProps = _objectSpread({}, !disabled && clickable && {
    focusVisibleClassName: mergedClasses.focusVisible
  });
  var localDeleteIcon = !deleteIcon && onDropDown ? /*#__PURE__*/_react["default"].createElement(_ArrowDropDown["default"], {
    className: (0, _classnames["default"])(mergedClasses.icon, (0, _defineProperty2["default"])({}, mergedClasses.iconDisabled, disabled))
  }) : deleteIcon;

  // if onDelete is passed in, set onDelete prop as the onDeleteHandler
  // if onDropDown is passed in and no deleteIcon is passed in, set onDropDown prop function as the onDeleteHandler
  // sideNote: deleteIcon doesn't show unless onDelete is passed in, that is why it is needed
  // if chip is disabled, pass in empty function otherwise the deleteIcon will not show
  var onDeleteLogic = onDelete && (disabled ? function () {} : onDelete);
  var onDropDownLogic = onDropDown && !deleteIcon ? onDropDown : null;
  var onDeleteHandler = onDeleteLogic || onDropDownLogic;
  var toggleIsActiveEventHandler = (0, _react.useCallback)(function (event) {
    event.preventDefault();
    event.stopPropagation();
    if (!selected) {
      setIsChipActive(!isChipActive);
    }
  }, [isChipActive, selected, setIsChipActive]);
  return /*#__PURE__*/_react["default"].createElement(_Chip["default"], (0, _extends2["default"])({
    classes: _objectSpread({}, classes, {
      clickable: mergedClasses.clickable,
      clickableColorPrimary: mergedClasses.clickableColorPrimary,
      colorPrimary: mergedClasses.colorPrimary,
      deleteIcon: (0, _classnames["default"])(mergedClasses.deleteIcon, (_cx2 = {}, (0, _defineProperty2["default"])(_cx2, mergedClasses.iconDisabled, disabled), (0, _defineProperty2["default"])(_cx2, mergedClasses.iconSmall, isSmall), _cx2)),
      icon: (0, _classnames["default"])(mergedClasses.icon, (0, _defineProperty2["default"])({}, mergedClasses.iconSmall, isSmall)),
      iconColorPrimary: mergedClasses.iconColorPrimary,
      label: (0, _classnames["default"])(mergedClasses.label, (_cx4 = {}, (0, _defineProperty2["default"])(_cx4, mergedClasses.labelSelected, !disabled && selected), (0, _defineProperty2["default"])(_cx4, mergedClasses.labelSmall, isSmall), _cx4)),
      outlinedPrimary: mergedClasses.outlinedPrimary,
      root: (0, _classnames["default"])(mergedClasses.root, (_cx5 = {}, (0, _defineProperty2["default"])(_cx5, mergedClasses.outlined, variant === 'outlined'), (0, _defineProperty2["default"])(_cx5, mergedClasses.disabled, disabled), (0, _defineProperty2["default"])(_cx5, mergedClasses.selected, !disabled && selected), (0, _defineProperty2["default"])(_cx5, mergedClasses.chipActive, isChipActive), _cx5))
    }),
    clickable: !disabled && clickable,
    color: color,
    "data-metrics": mergedDataMetrics.root,
    deleteIcon: localDeleteIcon,
    icon: icon,
    label: /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      className: (0, _classnames["default"])(mergedClasses.label, (_cx6 = {}, (0, _defineProperty2["default"])(_cx6, mergedClasses.labelAlternativeSelected, !disabled && selected && alternativeSelectedStyle), (0, _defineProperty2["default"])(_cx6, mergedClasses.labelDisabled, disabled), (0, _defineProperty2["default"])(_cx6, mergedClasses.labelOutlined, variant === 'outlined'), (0, _defineProperty2["default"])(_cx6, mergedClasses.labelSelected, !disabled && selected), (0, _defineProperty2["default"])(_cx6, mergedClasses.labelSmall, isSmall), _cx6)),
      variant: isSmall ? 'overline' : 'body1'
    }, label),
    onMouseDown: toggleIsActiveEventHandler,
    onMouseUp: toggleIsActiveEventHandler,
    onDelete: onDeleteHandler,
    ref: ref,
    size: size,
    variant: variant
  }, focusVisibleProps, rest));
});
Chip.defaultProps = defaultProps;
Chip.displayName = 'Chip';
Chip.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * @deprecated
   * Use the alternative styling when the selected prop is true.
   */
  alternativeSelectedStyle: function alternativeSelectedStyle(props, propName) {
    if (props[propName]) {
      // eslint-disable-next-line no-console
      console.warn("The prop '".concat(propName, "' has been deprecated. Please either override the chip styles using the 'classes' prop or remove the '").concat(propName, "' prop on the Chip component."));
    }
  },
  /**
   * Avatar element.
   */
  avatar: _propTypes["default"].element,
  /**
   * This property isn't supported.
   * Use the `component` property if you need to change the children structure.
   */
  children: _unsupportedProp["default"],
  /**
   * @ignore
   * Override or extend the styles applied to the component.
   * See [CSS API](https://v4.mui.com/api/chip/#css) for more details.
   */
  classes: _propTypes["default"].object,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * If `true` the chip will appear clickable and will raise when pressed,
   * even if the onClick property is not defined.
   * If `false` the chip will not be clickable, even if onClick peoperty is defined.
   * This can be used, for example,
   * along with the component property to indicate an anchor Chip is clickable.
   */
  clickable: _propTypes["default"].bool,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes["default"].oneOf(['default', 'primary', 'secondary']),
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].object]),
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: _propTypes["default"].element,
  /**
   * If `true`, the select will be disabled.
   */
  disabled: _propTypes["default"].bool,
  /**
   * Icon element.
   */
  icon: _propTypes["default"].element,
  /**
   * The content of the label.
   */
  label: _propTypes["default"].node,
  /**
   * @ignore
   */
  onClick: _propTypes["default"].func,
  /**
   * Callback function fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: _propTypes["default"].func,
  /**
   * Callback function fired when the drop down icon is clicked.
   * If set, the drop down icon will be shown.
   */
  onDropDown: _propTypes["default"].func,
  /**
   * @ignore
   */
  onKeyDown: _propTypes["default"].func,
  /**
   * @ignore
   */
  onKeyUp: _propTypes["default"].func,
  /**
   * If true, chip will be rendered with the 'selected' styling
   * @ignore
   */
  selected: _propTypes["default"].bool,
  /**
   * The size of the Chip
   */
  size: _propTypes["default"].oneOf(['medium', 'small']),
  /**
   * @ignore
   */
  tabIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  /**
   * The variant to use.
   */
  variant: _propTypes["default"].oneOf(['default', 'outlined'])
} : {};
var _default = Chip;
exports["default"] = _default;